var cookies = (function($) {
  function init(){
    askCookiesPermission();
  }

  function askCookiesPermission() {
      window.cookieconsent.initialise({
          "palette": {
            "popup": {
              "background": "#00a650",
              "text": "#fff"
            },
            "button": {
              "background": "#007136",
              "text": "#ffff"
            }
          },
          "theme": "classic",
          "position": "bottom",
          "content": {
            "message": "Продължавайки да използвате този сайт, вие се съгласявате с използването на бисквитки.",
            "dismiss": "Разбрах!",
            "link": "Още ...",
            "href": "https://gioiaamore.bg//bg/terms"
          }
      });
  }

  return {
    init: init
  };

})(jQuery);

export default cookies;